// Typelizer digest 8033a3c674357e24604b01ffec21abd0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/documents/:document_id/documents */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/documents', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/documents/:document_id/documents/:id */
  destroy: (
    params: { documentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/documents/:id', params, options),
    method: 'delete',
  }),
}
